import { Link } from "react-router-dom";

/**
 * Site-wide footer. Renders the copyright line and legal/nav links.
 * Used on Landing, OrderWaiting, OrderSuccess, PaymentSuccess, PaymentCancel.
 */
export default function Footer({ className = "" }) {
  return (
    <footer
      data-testid="site-footer"
      className={`relative z-10 mt-12 border-t border-white/10 py-6 md:py-8 px-4 md:px-12 ${className}`}
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 md:gap-4 text-[11px] md:text-xs font-mono-display tracking-widest text-zinc-500">
        <div className="text-center sm:text-left">© {new Date().getFullYear()} · PORTAL GASOLINA B94</div>
        <div className="flex items-center gap-4 md:gap-5">
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-yellow-400 transition-colors uppercase"
          >
            Términos y Condiciones
          </Link>
          <Link
            to="/login"
            data-testid="footer-login-link"
            className="hover:text-yellow-400 transition-colors uppercase"
          >
            Iniciar sesión
          </Link>
        </div>
      </div>
    </footer>
  );
}
